/*eslint-disable */
import React, { Component } from 'react';

const findScreen = (windowWidth) => {
  if (windowWidth < 768) {
    return 'mobile'
  } else if (windowWidth < 992) {
    return 'tablet'
  }
  return 'desktop'
}

export default () => {
  return (WrappedComponent) => {
    class ScreenProvider extends Component {
      constructor(props){
        super(props)
        const { assets } = props
        this.state = {
          screen: findScreen(assets.initialWindowWidth || (typeof window !== 'undefined' ? window.innerWidth : 320))
        }

        this.handleResize = this.handleResize.bind(this)
      }

      componentDidMount() {
        window.addEventListener('resize', this.handleResize);
      }

      componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
      }

      handleResize() {
        this.setState({ screen: findScreen(window.innerWidth) })
      };

      render() {
        const { screen } = this.state;
        return (
          <WrappedComponent
            {...this.props}
            screen={screen}
          />
        );
      }
    }

    return ScreenProvider
  }
}



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/utils/withScreen.js